"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.player = void 0;
const player = function (player) {
    player._client.on('client_command', ({ payload } = {}) => {
        if (payload === 1) {
            // WIP: dummy
            player.system('WIP, press ESC');
        }
    });
};
exports.player = player;
